/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectIntegrationRuntimeStatus } from './ProjectIntegrationRuntimeStatus';
import {
    ProjectIntegrationRuntimeStatusFromJSON,
    ProjectIntegrationRuntimeStatusFromJSONTyped,
    ProjectIntegrationRuntimeStatusToJSON,
    ProjectIntegrationRuntimeStatusToJSONTyped,
} from './ProjectIntegrationRuntimeStatus';
import type { ProjectRuntimeStatus } from './ProjectRuntimeStatus';
import {
    ProjectRuntimeStatusFromJSON,
    ProjectRuntimeStatusFromJSONTyped,
    ProjectRuntimeStatusToJSON,
    ProjectRuntimeStatusToJSONTyped,
} from './ProjectRuntimeStatus';

/**
 * 
 * @export
 * @interface ProjectRuntimeOverview
 */
export interface ProjectRuntimeOverview {
    /**
     * 
     * @type {ProjectRuntimeStatus}
     * @memberof ProjectRuntimeOverview
     */
    projectRuntime?: ProjectRuntimeStatus;
    /**
     * 
     * @type {Array<ProjectIntegrationRuntimeStatus>}
     * @memberof ProjectRuntimeOverview
     */
    integrations?: Array<ProjectIntegrationRuntimeStatus>;
}

/**
 * Check if a given object implements the ProjectRuntimeOverview interface.
 */
export function instanceOfProjectRuntimeOverview(value: object): value is ProjectRuntimeOverview {
    return true;
}

export function ProjectRuntimeOverviewFromJSON(json: any): ProjectRuntimeOverview {
    return ProjectRuntimeOverviewFromJSONTyped(json, false);
}

export function ProjectRuntimeOverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRuntimeOverview {
    if (json == null) {
        return json;
    }
    return {
        
        'projectRuntime': json['projectRuntime'] == null ? undefined : ProjectRuntimeStatusFromJSON(json['projectRuntime']),
        'integrations': json['integrations'] == null ? undefined : ((json['integrations'] as Array<any>).map(ProjectIntegrationRuntimeStatusFromJSON)),
    };
}

export function ProjectRuntimeOverviewToJSON(json: any): ProjectRuntimeOverview {
    return ProjectRuntimeOverviewToJSONTyped(json, false);
}

export function ProjectRuntimeOverviewToJSONTyped(value?: ProjectRuntimeOverview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectRuntime': ProjectRuntimeStatusToJSON(value['projectRuntime']),
        'integrations': value['integrations'] == null ? undefined : ((value['integrations'] as Array<any>).map(ProjectIntegrationRuntimeStatusToJSON)),
    };
}

